import { ElementType, ReactNode } from 'react'
import { ButtonStyling, buttonStyling, iconStyling } from '$components'
import { LoaderIcon } from '$icons'
import { Link, LinkProps } from 'react-router-dom'

export type LinkButtonProps = {
  children?: ReactNode,
  icon?: ElementType,
  isLoading?: boolean,
  disabled?: boolean,
} & ButtonStyling & LinkProps

export function LinkButton({
  children,
  variant,
  size,
  intent,
  icon: Icon,
  isLoading,
  disabled,
  ...props
}: LinkButtonProps) {

  const IconComponent = Icon ? <Icon className={iconStyling({ size })} /> : null

  return (
    <Link
      {...props}
      className={buttonStyling({
        withIcon: Icon !== undefined,
        withChildren: children !== undefined,
        variant,
        size,
        intent,
        isDisabled: disabled,
        className: props.className,
      })}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault()
        }
      }}
    >
      { isLoading ? <LoaderIcon className={iconStyling({ size })} /> : IconComponent }
      { children }
    </Link>
  )
}
